import React, { useEffect } from 'react';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { useTranslation } from '../../contexts/translation';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { WorksheetsNewForm } from '../../forms/worksheetsDev/WorksheetsNewForm';
import { useLocation, useParams } from 'react-router-dom';
import { DetailWorkSheetParams } from '../../types/pageParams.types';

interface WorkSheetsNewState {
    customerProject: {
        customerProjectId?: number;
    }
}

export const WorksheetsNew = () => {
    const { translate } = useTranslation();
    const transFormName = 'WorkSheet.Create';
    const { setValue } = useBreadcrumbs();

    const { assetId, taskId } = useParams<DetailWorkSheetParams>();
    const { state }: { state: WorkSheetsNewState | undefined } = useLocation();


    useEffect(() => {
        setValue({
            pageName: 'New workSheet',
            steps: [
                { name: 'Home', pathToCutCount: 3 },
                { name: 'WorkSheets', pathToCutCount: 2 },
            ],
        });
        return () => {
            setValue(null);
        };
    }, []);

    return (
        <PageContentWrapper heading={translate!('New workSheet', transFormName)}>
            <WorksheetsNewForm defaultFormData={{
                assetId: assetId ? Number(assetId) : undefined,
                taskId: taskId ? Number(taskId) : undefined,
                customerProjectId: state && state.customerProject && state.customerProject.customerProjectId ? state.customerProject.customerProjectId : undefined,
            }} />
        </PageContentWrapper>
    );
}